export default "/_next/static/images/dog6-7e53d9068185345514c9fc047fe6ef15.png";